<h2 mat-dialog-title class="dialog-title">
  {{ data ? "Edit" : "Add" }} a custom enumeration value in data type
  {{ data.dataType }}
</h2>

<mat-dialog-content>
  <div class="form-row">
    <mat-form-field class="underline-only" appearance="fill" style="display: flex; align-items: center;">
      <!-- <mat-label>Value</mat-label> -->
      <span
        matPrefix
        style="margin-left: 16px; margin-right: 8px; line-height: 1.5"
        >OTHER:&nbsp;</span
      >
      <input
        matInput
        [(ngModel)]="customValue"
        placeholder="Enter value"
        #valueInput="ngModel"
        required
        pattern="[a-zA-Z0-9_]{1,58}"
      />
      <mat-error *ngIf="valueInput.invalid && valueInput.touched">
        Value must contain only letters, numbers, or _ (1–58 characters).
      </mat-error>
    </mat-form-field>

    <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
      <mat-label>Description</mat-label>
      <textarea
        matInput
        [(ngModel)]="description"
        rows="3"
        placeholder="Enter here..."
        maxlength="1000"
      ></textarea>
      <mat-hint align="end">{{ description?.length || 0 }}/1000</mat-hint>
    </mat-form-field>
  </div>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button
      mat-raised-button
      color="primary"
      (click)="onSave()"
      [disabled]="!isValid"
    >
      Save
    </button>
    <button mat-raised-button color="primary" (click)="onClose()">
      Cancel
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
